'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//


exports.default = {
  props: {
    content: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'colmo_plain' // colmo_plain colmo gray_plain green
    }
  },
  data: function data() {
    return {
      styleMap: {
        colmo_plain: {
          borderColor: '#B35336',
          backgroundColor: 'transparent',
          color: '#B35336',
          fontSize: '24px',
          borderRadius: '8px'
        },
        colmo: {
          borderColor: 'transparent',
          backgroundColor: 'rgba(194,94,62,0.18)',
          color: '#B35336',
          fontSize: '24px',
          borderRadius: '8px'
        },
        gray_plain: {
          borderColor: '#707070',
          backgroundColor: 'transparent',
          color: '#707070',
          fontSize: '24px',
          borderRadius: '8px'
        },
        green: {
          borderColor: '#06c270',
          backgroundColor: 'rgba(6,194,112,0.1)',
          color: '#06c270',
          fontSize: '24px',
          borderRadius: '8px'
        }
      }
    };
  },

  computed: {
    currentStyle: function currentStyle() {
      return this.styleMap[this.type] || {};
    }
  },
  methods: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-colmo-tag/index.vue
// module id = 326
// module chunks = 0 1